import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../core/config/api";
import PaymentResult from "./PaymentResult";
import { useHubSpotScript } from "../../utils/useHubSpotScript";

const PaymentCancel = () => {
  useHubSpotScript();
  const navigate = useNavigate();
  const sessionId = new URLSearchParams(window.location.search).get("session_id");

  // Stripe returns here when the customer leaves the checkout - including
  // after a declined card. If this checkout had a decline, show the Payment
  // Failed page (with the bank's reason) instead of "cancelled".
  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    apiClient
      .get(`/stripe-payment/status/${sessionId}`)
      .then(({ data }) => {
        if (!cancelled && data?.payment_failed) {
          navigate(`/payment/failed?session_id=${encodeURIComponent(sessionId)}`, { replace: true });
        }
      })
      .catch(() => {
        // Non-fatal: the cancelled message below still applies.
      });
    return () => {
      cancelled = true;
    };
  }, [sessionId, navigate]);

  return (
    <PaymentResult
      variant="error"
      title="Payment Cancelled"
      message="You cancelled the checkout before it was completed. You have not been charged."
      primary={{ label: "Back to Pricing", to: "/pricing" }}
      secondary={{ label: "Back to Dashboard", to: "/dashboard" }}
    />
  );
};

export default PaymentCancel;
